import Vue from "vue"
import { Component, Prop, Emit, Watch } from "vue-property-decorator"
import { IContactPersonViewModel } from "../../../../../../Scripts/inpulse/I4UViewModels";
import StreetAutocomplete from "../../../../../../Scripts/vue-components/bootstrap-components/street-autocomplete.vue";
import PostalAutocomplete from "../../../../../../Scripts/vue-components/bootstrap-components/postal-autocomplete.vue";
import { BvModalEvent } from 'bootstrap-vue'

@Component({
    components: {
        StreetAutocomplete,
        PostalAutocomplete
    }
})

export default class ContactPersonModal extends Vue {
    get street(): string { return this.contactPerson.Address.Street; }
    set street(val: string) { debugger;  this.contactPerson.Address.Street = val; }

    @Prop()
    value;

    @Watch("value")
    valueChanged(val: boolean) {
        this.show = this.value;
    }

    private show: boolean = false;
    private locale: string = null;

    @Watch("show")
    showChanged(val: boolean) {
        this.$emit("input", val);
    }

    @Prop()
    contactPerson: IContactPersonViewModel;

    @Emit()
    removeContactPerson(contactPerson: IContactPersonViewModel) { }

    @Emit()
    cancel() { }

    @Emit()
    ok(contactPerson: IContactPersonViewModel) { }

    constructor() {
        super();
    }

    beforeClose(msg) {
        if (msg == "cancel") {
            this.cancel();
            this.removeContactPerson(this.contactPerson);
        }
        return true;
    }

    hide(msg: BvModalEvent) {
        if (msg.trigger == "cancel") {
            this.cancel();
            this.removeContactPerson(this.contactPerson);
        }
        else if (msg.trigger == "ok")
            this.ok(this.contactPerson);
    }


    postOfficeSelected(postOffice: string) {
        this.contactPerson.Address.Place = postOffice;
    }

    postalSelected(postCode: string, locale: string) {
        this.locale = locale;
        this.contactPerson.Address.Zip = postCode;
        this.contactPerson.Address.Locale = locale;
    }

    streetSelected(street: string, locale: string) {
        this.locale = locale;
        this.contactPerson.Address.Street = street;
        this.contactPerson.Address.StreetName = street;
        this.contactPerson.Address.Locale = locale;
    }

    addressSelected(streetName: string, postalCode: string, postOffice: string, locale: string) {
        this.contactPerson.Address.Street = streetName;
        this.contactPerson.Address.StreetName = streetName;
        this.contactPerson.Address.Zip = postalCode;
        this.contactPerson.Address.Place = postOffice;
        this.contactPerson.Address.Locale = locale;
        this.locale = locale;
    }

    data() {
        return {
            show: false,
            variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark'],
            headerBgVariant: 'light',
            headerTextVariant: 'dark',           
            bodyTextVariant: 'dark',
            footerBgVariant: 'light'
        }
    }
}